import React from 'react';
import PropTypes from 'prop-types';
import { string } from 'yup';
import BaseInput from '../base';

const StreetTwo = props => {
  const { 'data-cv-test': dataCvTest } = props;

  return (
    <BaseInput
      name="street2"
      label="Address, Line 2"
      type="text"
      transparent
      validate={val =>
        string()
          .notRequired()
          .max(100, 'Address cannot be greater than 100 characters')
          .validate(val)
          .then(() => null)
          .catch(err => err.errors.join(', '))
      }
      {...props}
      data-cv-test-override={dataCvTest || 'addressStreetLineTwo'}
    />
  );
};

StreetTwo.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  error: PropTypes.string,
  'data-cv-test': PropTypes.string
};

StreetTwo.defaultProps = {
  value: '',
  error: '',
  'data-cv-test': ''
};

export default StreetTwo;
